import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import Spinner from 'components/UI/Spinner';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import { withRouter } from 'react-router-dom';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Immutable from 'immutable';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import { fetchData, getDataHome, getLoadingError } from '../../ducks/asyncFetcher';
import { isLoggedIn, getCurrentUserRole, getCurrentUser, isStateKnown } from 'ducks/authentication';
import clsx from 'clsx';
import Footer from '../Footer';
import i18n from 'helpers/i18n';
import Header from 'components/Header/Header';

const styles = (theme) => {
  return {
    root: {
      minWidth: '100%',
      height: '100%',
      // minHeight: '920px',
      color: '#fff',
      '& .MuiTypography-h1': {
        fontSize: '5rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '3.5rem',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '2.8rem',
        }

      },
      '& .MuiTypography-h2': {
        fontSize: '3.5rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '2.3rem',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '1.6rem',
        }
      }
    },
    main: {
      height: '70%'
    },
    footer: {
      height: '30%',
      color: '#fff',
      // height: 120,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
    logo: {
      width: 'clamp(80px, 40%, 180px)',
      display: 'block',
      marginBottom: theme.spacing(3),
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  };
};

const AF_KEY = 'home';

class HomeClass extends Component {
  constructor(props) {
    super(props);
    // this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this.state = {
      showLiveButton: false,
      timeRemaining: {},
    };
  }

  componentDidMount() {
    const { classes } = this.props;
    this.props.onMount();
  }

  render() {
    const { $$data, userRole, onPanelToggle, $$user, classes, subscribe, isLoggedIn, themeId } = this.props;
    const { showLiveButton, timeRemaining } = this.state;
    // const $$liveEvent = this._getMyLiveEvent();
    //
    // const $$subscriptions = this._getMySubscriptions();
    // let finalThemeId = themeId;
    //
    // const $$availableEvents =
    //   $$data !== undefined && $$data.get('availableEvents') !== undefined
    //     ? $$data.get('availableEvents')
    //     : undefined;
    // const $$pastEvents =
    //   $$data !== undefined && $$data.get('pastEvent') !== undefined ? $$data.get('pastEvent') : undefined;

    return (
      <Fade in timeout={1000} style={{ height: '100%' }}>
          <Container disableGutters style={{ height: '100%' }} maxWidth={false}>
            <ScrollToTopOnMount />
            <Header />
            <Grid container spacing={0} className={classes.root}>
              <Grid
                item
                xs={12}
                container
                alignContent="center"
                className={classes.main}
              >
              <img src={require('assets/logo.jpg')} className={classes.logo}/>
              <Typography variant="h1">K Particulier</Typography>
              <Typography variant="h2">Digital Medical Education</Typography>

              </Grid>
              <Footer className={classes.footer} colouredBackground={!isLoggedIn} />
            </Grid>
          </Container>
      </Fade>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

const HomeWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HomeClass)));

export default HomeWrapper;



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx